import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-button-group', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
